import script from "./HelpCenterLauncher.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpCenterLauncher.vue?vue&type=script&setup=true&lang=js"

import "./HelpCenterLauncher.vue?vue&type=style&index=0&id=5f319f2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f319f2a"]])

export default __exports__